import { IonButton } from '@ionic/react'
import React, { HTMLAttributes } from 'react'
import { setPNNVStateValues } from './store/pnnv.actions'
import { useDispatch } from 'react-redux'
import { IOptions, IPNNVOption } from '../../common/common.types'
import './PNNVIcon.component.css'

interface IPNNVIcon extends HTMLAttributes<HTMLIonButtonElement> {
  onChangeAction?: (e: CustomEvent) => void
  pnnvOptions?: IOptions
  pnnvValue?: IPNNVOption | null
  pnnvAction?: (...args: any[]) => any
  pnnvLabel?: string
  pnnvListHeader?: string
  nemsis?: string
  onButtonClick?: (e: React.MouseEvent<HTMLIonButtonElement>) => void
  className: string
  dataTestId: string
}

const PNNVIcon: React.FC<IPNNVIcon> = (props) => {
  const {
    pnnvOptions = [],
    pnnvValue = undefined,
    pnnvAction = () => void 0,
    pnnvLabel = '',
    pnnvListHeader = '',
    nemsis = 'nemsisCode',
    className = undefined,
    dataTestId = '',
  } = props
  const dispatch = useDispatch()

  return (
    <>
      <IonButton
        {...props}
        data-testid={dataTestId}
        fill='clear'
        shape='round'
        size='small'
        className={className}
        onClick={(e) => {
          e.preventDefault()
          props.onButtonClick?.(e)
          dispatch(
            setPNNVStateValues({
              customEvent: e,
              showPWAPNNVBar: false,
              pnnvOptions,
              pnnvValue,
              pnnvAction,
              pnnvLabel,
              pnnvListHeader,
              nemsis,
              isOpen: true,
            })
          )
        }}>
        <span tabIndex={-1} slot='icon-only' className='pnnv-icon-mark' />
      </IonButton>
    </>
  )
}

export default PNNVIcon
